import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { environment } from 'src/environments/environment';
import { ConnectionService } from 'ng-connection-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatSnackBar } from '@angular/material/snack-bar';

@UntilDestroy()
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingBarRouterModule],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  connectionService = inject(ConnectionService);
  snackBar = inject(MatSnackBar);
  title = 'talent-hub-lite-web-2';
  env = environment;

  ngOnInit(): void {
    this.connectionService
      .monitor()
      .pipe(untilDestroyed(this))
      .subscribe((isConnected) => {
        this.snackBar.dismiss();
        if (!isConnected.hasNetworkConnection) {
          this.snackBar.open(
            'You seem to be offline please check your internet connection.',
            'WARNING',
            null
          );
        }
      });
  }
}
